import React, { useEffect, useState } from "react";
import PointSpreadLoading from "react-loadingg/lib/PointSpreadLoading";
import { getAllsuperyDiscountApi } from "../../Api/ClientServices";
import More from "../../Component/More/More";
import Style from "../../Component/More/More";
import { errorToast } from "../../Toast/Toast";

const MoreDiscountSupery = () => {
  const [moreDiscount, setMoreDiscount] = useState();
  useEffect(() => {
    getDiscount();
  }, []);

  const getDiscount = async () => {
    getAllsuperyDiscountApi((succ, res) => {
      if (succ) {
        if (res.status === 1) {
          errorToast("مشکلی پیش آمده است");
        } else {
          setMoreDiscount(res.products);
        }
      } else {
        console.error(res);
      }
    });
  };

  return (
    <div className={Style.pageHolder}>
      {moreDiscount === undefined ? (
        <div>
          <PointSpreadLoading color={"#ab0c59"} size={"small"} />
        </div>
      ) : (
        <More
          data={moreDiscount}
          title={"تخفیف های فروشگاه"}
          headerText={"در بَرِست از تخفیف ها لذت ببرید"}
          category={getDiscount}
        />
      )}
    </div>
  );
};

export default MoreDiscountSupery;
